import '../vendor/jquery.vimeo.api';
import '../vendor/player';

export class CustomCursor {
	constructor() {
		this.container = document.querySelectorAll('.customCursor');
	}

	init() {
		this.container.forEach((container) => {
			container.addEventListener('click', () => {
				this.onClickVideo(container);
			});
		});
	}

	onClickVideo(container) {
		const iframe = container.querySelector('iframe');
		let videoContentPlayer = new Vimeo.Player(iframe);

		container.classList.toggle('played');

		if (container.classList.contains('played')) {
			videoContentPlayer.play();
			videoContentPlayer.setVolume(1);
		} else {
			videoContentPlayer.pause();
		}
	}
}
